import { Component, Input } from '@angular/core';
import { CompanyImportResponse, JobStatus } from '../../../../../../../../../core/model/company-import-text.model';

@Component({
  selector: 'app-massive-company-import-outcome',
  templateUrl: './massive-company-import-outcome.component.html',
  styleUrls: ['./massive-company-import-outcome.component.scss'],
})
export class MassiveCompanyImportOutcomeComponent {

  @Input() jobStatus!: CompanyImportResponse;
  JobStatus = JobStatus;

  constructor() {
  }
}
